
import Submenu from '~/components/Navigation/Submenu.vue'

export default {
    components: { Submenu },
    props: {
        item: Object,
    },
    data() {
        return {
            activeClass: '',
            isSubmenuOpen: false,
        }
    },
    created() {
		this.$nuxt.$on('openSubMenu', this.handleOpenSubMenu)
		this.$nuxt.$on('closeAllSubmenus', this.handleCloseAllSubmenus)
    },
	beforeDestroy() {
		this.$nuxt.$off('openSubMenu', this.handleOpenSubMenu)
		this.$nuxt.$off('closeAllSubmenus', this.handleCloseAllSubmenus)
	},
    methods: {
        toggleSubmenu(event) {
			event.preventDefault();
			if (this.isSubmenuOpen) {
				this.isSubmenuOpen = false;
				this.$nuxt.$emit('closeSubMenu');
			} else {
				this.isSubmenuOpen = true;
				this.$nuxt.$emit('openSubMenu', this.item.name);
			}
        },
		handleOpenSubMenu(name) {
			if (this.item.name === name) {
				if (!this.isSubmenuOpen) {
					this.isSubmenuOpen = true;
					this.$nuxt.$emit('openSubMenu');
				}
				this.activeClass = 'navItem__item-active';
			} else {
				if (this.isSubmenuOpen) {
					this.isSubmenuOpen = false;
					this.$nuxt.$emit('closeSubMenu');
				}
				this.activeClass = '';
			}
		},
		handleCloseAllSubmenus() {
			if (this.isSubmenuOpen) {
				this.isSubmenuOpen = false;
				this.$nuxt.$emit('closeSubMenu');
			}
			this.activeClass = '';
		},
    },
}
